import ButtonSpec from 'componentSpecs/button.json'
import { FormEvent, useState } from 'react'

import { PktTextinput } from '@/components'
import { IPktButton, PktButton } from '@/components/button/Button'
import IButtonSpec from '@/interfaces/IButtonSpec'

export default function Button() {
  const buttonSpec = ButtonSpec as unknown as IButtonSpec
  const [specProps] = useState(buttonSpec.props)

  function buttonClick(name: string, sizeType?: string, variantType?: string, stateType?: string) {
    console.log('Button clicked:', name)
  }

  const handleInsideSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    console.count('handleInsideSubmit called')

    const form = e.currentTarget
    const formData = new FormData(form)
    console.table(Object.fromEntries(formData))
  }

  const handleOutsideSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    console.count('handleOutsideSubmit called')

    const form = e.currentTarget
    const formData = new FormData(form)
    console.table(Object.fromEntries(formData))
  }

  return (
    <main className="page-main pkt-container pkt-container--laptop">
      <h1>Button</h1>

      <h2>Interactive Form (Submit Button inside form)</h2>
      <form onSubmit={handleInsideSubmit} style={{ marginBottom: '2rem', gap: '1rem' }}>
        <label>
          Navn:
          <PktTextinput id="input-inside" label="Inside" name="name" type="text" required />
        </label>
        <div>
          <PktButton type="submit" style={{ margin: '0.5rem' }}>
            Submit Form
          </PktButton>
          <PktButton type="reset" style={{ margin: '0.5rem' }}>
            Reset Form
          </PktButton>
        </div>
      </form>

      <hr />
      <div>
        <h2>Interactive Form (Submit Button outside)</h2>
        <form id="myForm" onSubmit={handleOutsideSubmit} style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', margin: '0.5rem 0' }}>
            Navn:
            <PktTextinput id="input-outside" label="Outside" name="name" type="text" required></PktTextinput>
          </label>
        </form>

        <PktButton form="myForm" type="submit" style={{ margin: '0.5rem' }}>
          Submit Form (Outside)
        </PktButton>
        <PktButton form="myForm" type="reset" style={{ margin: '0.5rem' }}>
          Reset Form (Outside)
        </PktButton>
      </div>

      <section className="component">
        <h2>Native button using CSS-classes from Punkt</h2>
        <button type="button" className="pkt-btn pkt-btn--default">
          <span>Button</span>
        </button>
        <br />
        <br />
        <button type="button" className="pkt-btn pkt-btn--secondary">
          <span>Button</span>
        </button>
      </section>
      {specProps.skin.type.map((skinType: IPktButton['skin'], index: number) => (
        <section className="component" key={`skin-${index}`}>
          <h2>Skin: {skinType}</h2>
          <div className="component__block-example">
            {specProps.size.type.map((sizeType: IPktButton['size'], i: number) => (
              <div key={`skin-${index}-${i}-variant`} className="component__example">
                {specProps.variant.type.map((variantType: IPktButton['variant'], j: number) => (
                  <PktButton
                    className="okayokay"
                    key={`skin-${index}-${i}-variant-${j}`}
                    size={sizeType}
                    skin={skinType}
                    variant={variantType}
                    onClick={() => buttonClick(variantType || 'default', sizeType, variantType)}
                    iconName="close"
                  >
                    {variantType}
                  </PktButton>
                ))}
              </div>
            ))}
          </div>

          <div className="component__block-example">
            {specProps.size.type.map((sizeType: IPktButton['size'], i: number) => (
              <div key={`size-${i}`} className="component__example">
                {specProps.variant.type.map((variantType: IPktButton['variant'], j: number) => (
                  <PktButton
                    key={`skin-${index}-${i}-variant-${j}-disabled`}
                    size={sizeType}
                    skin={skinType}
                    variant={variantType}
                    disabled
                    onClick={() => buttonClick(variantType || 'default', sizeType, variantType)}
                  >
                    {variantType}
                  </PktButton>
                ))}
              </div>
            ))}
          </div>
          <div className="component__block-example">
            {specProps.size.type.map((sizeType: IPktButton['size'], i: number) => (
              <div key={`size-${i}`} className="component__example">
                {specProps.state?.type?.map((stateType: IPktButton['state'], j: number) => (
                  <PktButton
                    key={`skin-${index}-${i}-state-${j}`}
                    size={sizeType}
                    skin={skinType}
                    variant={specProps.variant.type[1]}
                    className={`pkt-btn--${stateType}`}
                    isLoading={stateType === 'active'}
                    onClick={() => buttonClick(stateType || 'default', sizeType, undefined, stateType)}
                  >
                    {stateType === 'active' ? `${stateType} & loading` : stateType}
                  </PktButton>
                ))}
              </div>
            ))}
          </div>
        </section>
      ))}

      <section className="component">
        <div className="component__block-example">
          <h3>Boolean types</h3>
          <PktButton disabled={true}>disabled=true</PktButton>
          <br />
          <PktButton disabled={false}>disabled=false</PktButton>
          <br />
          <PktButton disabled>disabled</PktButton>
          <br />
          <PktButton isLoading={true}>isLoading=true</PktButton>
          <br />
          <PktButton isLoading={false}>isLoading=false</PktButton>
          <br />
          <PktButton isLoading>isLoading</PktButton>
          <br />
          <PktButton isLoading disabled>
            isLoading + disabled
          </PktButton>
        </div>
      </section>

      <section className="component">
        <h2>Colors</h2>
        <div className="component__block-example">
          {specProps.color.type.map((colorType, i) => (
            <div key={`color-${i}`}>
              <PktButton key={`color-${i}`} color={colorType} onClick={() => buttonClick(colorType)}>
                {colorType}
              </PktButton>
            </div>
          ))}
        </div>
      </section>

      <section className="component">
        <h2>ButtonAsLink</h2>
        <div className="component__block-example">
          <button type="button" className="pkt-link pkt-link-button">
            <span>Button</span>
          </button>
        </div>
      </section>
    </main>
  )
}
